var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUsers1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.034 28c5.36 0 9.73 4.23 9.957 9.534l.009.432V40a2 2 0 0 1-3.987.233L26 40v-2.034a5.966 5.966 0 0 0-5.615-5.956l-.351-.01h-8.068a5.966 5.966 0 0 0-5.956 5.615l-.01.351V40a2 2 0 0 1-3.987.233L2 40v-2.034c0-5.36 4.23-9.73 9.534-9.957l.432-.009h8.068zM16 8.04A8.98 8.98 0 1 1 16 26a8.98 8.98 0 0 1 0-17.96zM34 12a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm-18 .04A4.98 4.98 0 1 0 16 22a4.98 4.98 0 0 0 0-9.96zM34 16a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm2.204 12c5.36 0 9.73 4.23 9.957 9.534l.009.432V40a2 2 0 0 1-3.987.233L42.17 40v-2.034a5.966 5.966 0 0 0-5.615-5.956l-.351-.01H34a2 2 0 0 1-.233-3.987L34 28h2.204zM6 36.04v4H2v-4h4z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUsers1);
export default __webpack_public_path__ + "static/media/icons-users-1.22651d0788c407611e8b2cdcf9f59af2.svg";
export { ForwardRef as ReactComponent };